import { createEntityMetadataMap } from '@mri-platform/shared/entity';
import { Mapper } from '../models';

export const entityMetadata = createEntityMetadataMap(Mapper);
